<template lang="pug">

  v-container(fluid)
    #start_animation_wrap(v-if="is_playing")
      img#start_animation(src="~@/assets/images/calc_animation.gif" @load="Playback")
    #main_wrapper(v-else)
      #left_col
        a(href="https://td.alliance.digital/")
          img(src="~@/assets/images/logo_black.svg")
        h1
          a(href="https://td.alliance.digital/") КАЛЬКУЛЯТОР ТРАФИКА
        CalcForm(
          v-if="current_month"
          :products="products"
          :ages="ages"
          :alternative_ages="alternative_ages"
          :ages_old_products="ages_old_products"
          :sexes="sexes"
          :interests="interests"
          :current_month="current_month"
          :max_month="max_month"
          :platforms_list="platforms_list"
          :platforms_mapper="platforms_mapper"
          @popping_up="PoppingUp"
          @product_changer="ProductChanger"
        )
      #right_col
        CalcTable#calc_table_wrap(
          :reach="reach"
          :type_of_data="type_of_data"
          :impressions_ratio="impressions_ratio"
          :limit_impressions="limit_impressions"
          :impressions="impressions"
          :regions="regions"
          :raw_data="raw_data"
          :choosen_product="product"
          :shown_product="shown_product"
          :frequency="frequency"
          :frequency_period="frequency_period"
          :frequency_period_banner="frequency_period_banner"
          :frequency_period_value="frequency_period_value"
          :slider="slider"
          @type_of_data_change="type_of_data = $event"
          @table_update="TableUpdate"
        )

</template>

<script>

import CalcForm from "./CalcForm.vue";
import CalcTable from "./CalcTable.vue";
import { initialRequest } from "../api/index";
import { commonMixin } from "../shared/mixins";

export default {
  name: 'MainPage',
  components: {
    CalcForm,
    CalcTable
  },
  data () {
    return {
      ages: [],
      ages_old_products: [],
      alternative_ages: [],
      platforms_mapper: [],
      platforms_list: [],
      interests: [],
      sexes: [],
      products: [],
      product_banner_id: null,
      product_flex_sheet_id: 7,
      show_form_value: null,
      reach: null,
      type_of_data: null,
      impressions_ratio: null,
      limit_impressions: null,
      impressions: null,
      regions: null,
      raw_data: null,
      is_playing: false,
      product: null,
      shown_product: null,
      frequency: null,
      frequency_period: null,
      frequency_period_banner: null,
      frequency_period_value: null,
      slider: null,
      current_month: null,
      max_month: null,
      order: [2, 12, 4, 1, 11, 3, 6, 8, 5, 10, 9]
    }
  },
  mixins: [
    commonMixin  
  ],
  mounted () {
    this.initialRequest()
    // this.Playback()
  },
  methods: {
    
    Playback () {
      setTimeout(() => {
        this.is_playing = false
      }, 2900)
    },
    ProductChanger (value) {
      this.product = value
    },
    PoppingUp (
      reach,
      type_of_data,
      impressions_ratio,
      limit_impressions,
      impressions,
      regions,
      raw_data,
      frequency,
      frequency_period,
      frequency_period_banner,
      frequency_period_value,
      shown_product,
      slider
    ) {
      this.reach = reach
      this.type_of_data = type_of_data
      this.impressions_ratio = impressions_ratio
      this.impressions = impressions
      this.limit_impressions = limit_impressions
      this.regions = regions
      this.raw_data = raw_data
      this.frequency = frequency
      this.frequency_period = frequency_period
      this.frequency_period_banner = frequency_period_banner
      this.frequency_period_value = frequency_period_value
      this.slider = slider
      this.shown_product = shown_product
    },
    TableUpdate (table, table_name) {
      this[table_name] = table
    },
    async initialRequest() {
      let token = this.getTokenFromCookies()
      let data = await initialRequest(this, token)
      let alternative_data_ages = JSON.parse(JSON.stringify(data['ages']))
      let ages_old_products = JSON.parse(JSON.stringify(data['ages']))
      function sort_ages (a, b) {
        let text_a = a["text"]
        let text_b = b["text"]
        if (text_a < text_b) {
          return -1;
        }
        if (text_a > text_b) {
          return 1;
        }
        return 0;
      }
      if (data) {
        for (let q=0; q<data['ages'].length; q++) {
          // if (data['ages'][q]['text'] == '0-18') {
          //   data['ages'].splice(q, 1)
          // }
          if (data['ages'][q]['text'] == '55-64') {
            data['ages'].splice(q, 1)
          }
          if (data['ages'][q]['text'] == 'Не определён') {
            data['ages'].splice(q, 1)
          }
        }
        for (let q=0; q<data['products'].length; q++) {
          if (data['products'][q]['value'] == this.product_flex_sheet_id) {
            data['products'].splice(q, 1)
          }
        }
        for (let q=0; q<alternative_data_ages.length; q++) {
          // if (alternative_data_ages[q]['text'] == '0-18') {
          //   alternative_data_ages.splice(q, 1)
          // }
          if (alternative_data_ages[q]['text'] == '55-64') {
            alternative_data_ages.splice(q, 1)
          }
        }
        for (let q=0; q<ages_old_products.length; q++) {
          if (ages_old_products[q]['text'] == '0-18') {
            ages_old_products.splice(q, 1)
          }
          if (ages_old_products[q]['text'] == '55-64') {
            ages_old_products.splice(q, 1)
          }
        }
        
        this.ages = data['ages'].sort(sort_ages)
        this.alternative_ages = alternative_data_ages.sort(sort_ages)
        this.ages_old_products = ages_old_products.sort(sort_ages)
        for (let index in data['devices']) {
          this.platforms_mapper[data['devices'][index]['text']] = data['devices'][index]['value']
        }
        this.platforms_list = []
        for (let i=0; i<data['devices'].length; i++) {
          let platform = data['devices'][i]['text'].split("_")
          let is_smart_tv = false
          for (let q=0; q<platform.length; q++) {
            if (platform[q] == 'smart') {
              is_smart_tv = true
              platform.splice(q, 1)
            }
            if (platform[q] == 'tv') {
              is_smart_tv = true
              platform.splice(q, 1)
            }
          }
          if (is_smart_tv) {
            platform.push('smart_tv')
          }
          this.platforms_list.push(platform.sort())
        }
        this.interests = data['interests']
        data['sexes'].splice(3)
        this.sexes = data['sexes']
        let actual_products = []
        for (let ind in data['products']) {
          actual_products.push(data['products'][ind])
        }

        let sorted_products = actual_products.slice().sort((a, b) => {
          return this.order.indexOf(a.value) - this.order.indexOf(b.value);
        });
        this.products = sorted_products;

        for (let ind in data['products']) {
          if (data['products'][ind]['text'] == 'Banner Network Reach') {
            this.product_banner_id = data['products'][ind]['value']
          }
        }
        this.show_form_value = true
        let year = parseInt(data['current_year'], 10)
        let month = data['current_month']
        this.current_month = String(year) + '-' + month
        this.max_month = String(year + 1) + '-' + month
      }
    }
  }
}
</script>

<style lang="sass">
.container
  min-height: 100%
  padding: 0 !important
  #main_wrapper
    width: 100%
    min-height: 100vh
    margin-right: auto
    margin-left: auto
    display: flex
    #left_col   
      width: 280px
      min-height: 100vh
      background-color: #F6F7F9
      padding: 5px 20px
      a img
        margin-top: 10px
        width: 240px
        height: auto
      h1
        color: #165FA8
        font-size: 14px
        font-weight: 700
        margin-bottom: 10px
        a
          color: #165FA8
          text-decoration: none
    #right_col
      width: calc(100% - 280px)
      height: 100%
      min-height: 100vh
      background: url("~@/assets/images/calc_bg.svg") no-repeat center center
      #calc_table_wrap
        background-color: #fff
  #start_animation_wrap
    display: flex
    align-items: center
    justify-content: center
    min-height: 100vh
    width: 100%
    background-color: #f5f5f5

</style>
